export default "__VITE_ASSET__eWImHa0g__"